import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Skeleton, Chip } from '@mui/material';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { red, orange, amber, blue, purple, grey } from '@mui/material/colors';
import api from '../../../services/api';

const CAUSE_COLORS = {
    'Timeout':           red[600],
    'Sem rota':          orange[700],
    'DNS':               amber[700],
    'Conexão recusada':  purple[600],
    'Credencial':        red[800],
    'SSH':               blue[600],
    'Template/Comando':  purple[800],
    'Outras':            grey[500],
};

const PERIODS = [
    { value: '7d',  label: '7 dias' },
    { value: '30d', label: '30 dias' },
    { value: '90d', label: '90 dias' },
];

const fmtDate = (s) => {
    const d = new Date(s + 'T00:00');
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
};

export default function CausesTrend() {
    const [period, setPeriod] = useState('30d');
    const [data, setData] = useState({ series: [], causes: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/hermes/dashboard/causes_trend?period=${period}`)
            .then(r => setData(r.data || { series: [], causes: [] }))
            .finally(() => setLoading(false));
    }, [period]);

    const hasData = data.series.some(d => data.causes.some(c => (d[c] || 0) > 0));

    return (
        <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} flexWrap="wrap" gap={1}>
                <Typography variant="h6" sx={{ fontFamily: 'Montserrat', fontWeight: 500 }}>
                    Causas ao longo do tempo
                </Typography>
                <Box display="flex" gap={0.5}>
                    {PERIODS.map(p => (
                        <Chip key={p.value} label={p.label} size="small"
                              onClick={() => setPeriod(p.value)}
                              color={period === p.value ? 'primary' : 'default'}
                              variant={period === p.value ? 'filled' : 'outlined'} />
                    ))}
                </Box>
            </Box>

            {loading ? (
                <Skeleton variant="rectangular" height={260} />
            ) : !hasData ? (
                <Box height={260} display="flex" alignItems="center" justifyContent="center">
                    <Typography variant="body2" color="text.secondary">
                        Sem falhas registradas no período.
                    </Typography>
                </Box>
            ) : (
                <ResponsiveContainer width="100%" height={260}>
                    <AreaChart data={data.series}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="date" tickFormatter={fmtDate} minTickGap={20} />
                        <YAxis allowDecimals={false} />
                        <Tooltip labelFormatter={fmtDate} />
                        <Legend />
                        {data.causes.map((c) => (
                            <Area key={c} type="monotone" dataKey={c} stackId="1"
                                  stroke={CAUSE_COLORS[c] || grey[400]}
                                  fill={CAUSE_COLORS[c] || grey[400]}
                                  fillOpacity={0.7} />
                        ))}
                    </AreaChart>
                </ResponsiveContainer>
            )}
        </Paper>
    );
}
